import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-preview-button-sm',
  templateUrl: './preview-button-sm.component.html',
  styleUrls: ['./preview-button-sm.component.scss']
})
export class PreviewButtonSmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
